<!-- files for NS client -->
@if (
  type !== 'post' &&
  type !== 'pcn' &&
  type != 'message' &&
  app.customers.expectCurrent === 'ns'
  ) {
  <div
    >
    <div class="col-md-12 templatesHeading my-2 mx-1">
      {{ app.text.attachments.safetyEvaluationTemplates }}
    </div>
    <div class="col-md-12 ns-templates mb-3 p-1">
      <a href="./assets/docs/Aanpak_OM_en_BTWM_proces.docx" target="_blank"
        >Aanpak_OM_en_BTWM_proces.docx</a
        >
      </div>
    </div>
  }
  @if (type !== 'thread' && type !== 'ocPost') {
    <div class="col-md-12">
      @for (attachment of attachments; track attachment) {
        <app-attachment
          [type]="type"
          [id]="id"
          [editPermission]="editPermission"
          [fileName]="attachment"
          [fileDetails]="filesDetails[attachment]"
        ></app-attachment>
      }
    </div>
  }
  @if (type === 'thread') {
    <div class="row">
      <div class="col-md-12">
        @if (tagsReady) {
          <div class="dropdown pull-right">
            <button
              class="btn dropdown-toggle"
              type="button"
              id="dropdownMenuButtonTags"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              [ngbTooltip]="app.text.attachments.tagText"
              >
              <i class="fas fa-eye"></i>
              <span>&nbsp;{{ app.text.attachments.showMode }} &nbsp;</span>
              <span class="text-danger">
                {{ app.attachments.getTagText(app.attachments.viewMode) }}
              </span>
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              @for (tag of app.attachments.caseTags; track tag) {
                <a
                  class="dropdown-item pointer"
                  (click)="app.attachments.getAttachmentsByTag(tag)"
          [ngClass]="{
            lightBackground: tag === 'noTag'
          }"
                  >
                  {{ app.attachments.getTagText(tag) }}
                </a>
              }
            </div>
          </div>
        }
        @if (tagsReady) {
          <div class="dropdown pull-right">
            <button
              class="btn dropdown-toggle"
              type="button"
              id="dropdownMenuButtonSortingOrder"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              [ngbTooltip]="app.text.attachments[app.attachments.sortingOrder]"
              >
              <span>&nbsp;{{ app.text.home.sort }}&nbsp;</span>
              <span class="text-danger">
                <i
                  class="fas"
            [ngClass]="{
              'fa-sort-amount-down':
                app.attachments.sortingOrder === 'descending',
              'fa-sort-amount-up': app.attachments.sortingOrder === 'ascending'
            }"
                ></i>
                {{ app.text.attachments.uploadTime }}
              </span>
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              @if (app.attachments.sortingOrder !== 'ascending') {
                <div
                  class="dropdown-item pointer"
                  >
                  <i class="fas fa-sort-amount-up"></i>
                  <a
            (click)="
              app.attachments.sortingOrder = 'ascending';
              app.attachments.sortAttachments('ascending')
            "
                    >
                    {{ app.text.attachments.uploadTime }}</a
                    >
                  </div>
                }
                @if (app.attachments.sortingOrder !== 'descending') {
                  <div
                    class="dropdown-item pointer"
                    >
                    <i class="fas fa-sort-amount-down"></i>
                    <a
            (click)="
              app.attachments.sortingOrder = 'descending';
              app.attachments.sortAttachments('descending')
            "
                      >
                      {{ app.text.attachments.uploadTime }}</a
                      >
                    </div>
                  }
                </div>
              </div>
            }
          </div>
          <div class="col-md-12 text-center p-1">
            @if (
              attachments.length === 0 && app.thread.thread['thread.pcnLink'] === ''
              ) {
              <small
                >{{ app.text.app.noResults }}</small
                >
              }
            </div>
          </div>
        }

        @if (
          (attachments.length > 0 || app.thread.thread['thread.pcnLink'] !== '') &&
          type === 'thread'
          ) {
          <div
            class="col-md-12"
            >
            @if (type !== 'post' && type !== 'message') {
              <div
                class="attachmentsText my-2 mx-1"
                >
                {{ app.text.attachments.allAttachments }}
              </div>
            }
            <div class="row" [ngClass]="{'overflow': attachments && attachments.length > 16}">
              @for (attachment of attachments; track attachment) {
                <app-attachment
                  [type]="type"
                  [id]="id"
                  [editPermission]="editPermission"
                  [fileName]="attachment"
                  [fileDetails]="app.attachments.getAttachmentHistory(attachment)"
                ></app-attachment>
              }
            </div>
          </div>
        }
        @if (type === 'thread' && app.thread.thread['thread.pcnLink'] !== '') {
          <div
            class="col-md-12"
            >
            <div class="attachmentName p-1">
              <a [href]="app.thread.thread['thread.pcnLink']" target="_blank">{{
                app.field.getLabel(app.fieldId.alert.pcnSource)
              }}</a>
            </div>
          </div>
        }

        @if (attachments.length > 0 && type === 'ocPost') {
          <div class="col-md-12">
            @for (attachment of attachments; track attachment) {
              <app-attachment
                [type]="type"
                [id]="id"
                [editPermission]="editPermission"
                [fileName]="attachment"
                [fileDetails]="app.attachments.getAttachmentHistory(attachment)"
              ></app-attachment>
            }
          </div>
        }
